import { initializeApp } from "firebase/app";
import { getRemoteConfig } from "firebase/remote-config";
import { fetchAndActivate } from "firebase/remote-config";
import { getValue } from "firebase/remote-config";

import configuration from '../envConfig';

const app = initializeApp(configuration.firebaseConfig);
const remoteConfig = getRemoteConfig(app);

remoteConfig.settings.minimumFetchIntervalMillis = configuration.firebaseConfig.minimumFetchIntervalMillis;

const configFirebase = () => {
    try {
        return fetchAndActivate(remoteConfig).finally(() => window.firebaseLoaded = true);
    } catch (error) {
        console.warn('Firebase fetchAndActivate error:', error);
        return Promise.reject(error);;
    }
};

export const getConfig = (key) => {
    try {
        return getValue(remoteConfig, key)._value;
    } catch (error) {
        console.warn('Firebase getConfig error:', error);
        return null;
    }
};

export default configFirebase;